<template>
  <div>
    <list
      ref="refAcademicTrainingList"
      sort-by="FormacionAcademicaId"
      :refetch-records="fetchAcademicsTraining"
      refetch-records-name="formacionesAcademicas"
      :actions="actions"
      key-field="formacionAcademicaId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteAcademicTraining"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refAcademicTrainingList = ref(null)
    /* Services */
    const {
      fetchAcademicsTraining,
      deleteAcademicTraining,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.academicTraining.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.academicTraining.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'FormacionAcademica',
        routeName: 'apps-human-resources-academic-training-edit',
        params: ['formacionAcademicaId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'FormacionAcademica',
        params: ['formacionAcademicaId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-academic-training-add',
        label: i18n.t('Routes.AcademicTrainingAdd'),
        aclAction: 'create',
        aclResource: 'FormacionAcademica',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refAcademicTrainingList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchAcademicsTraining,
      deleteAcademicTraining,
    }
  },
}
</script>
